import React from 'react';

function SearchBar({ value, onChange }) {
  return (
    <div className="search-bar">
      <input
        type="text"
        className="search-bar_input form-control mb-3"
        placeholder="Search for a question..."
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default SearchBar;
